module.exports = __webpack_public_path__ + "img/circle-1.754a210.png";